
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  model: {
    prop: "nextMileageNum",
    event: "change"
  }
})
export default class NextMileageInput extends Vue {
  @Prop({ type: [Number, String], default: 0 })
  currentMileage: number | string;

  @Prop({ type: [Number, String] })
  nextMileageNum: number | string;

  value: any = "";
  addNum = "";
  handleAdd(val) {
    this.value = Number(this.currentMileage) + Number(val);
    this.$emit("change", this.value);
  }
  handleClearAdd() {
    this.value = Number(this.currentMileage);
    this.$emit("change", this.value);
  }
  handleClear() {
    this.value = "";
    this.$emit("change", this.value);
  }
  handleMileageInput(val) {
    this.value = val;
    this.addNum = "";
    this.$emit("change", this.value);
  }
  @Watch("nextMileageNum", { immediate: true })
  nextMileageNumChange(val) {
    this.value = val || "";
  }
}
